import API_ENDPOINTS from "../config/apiConfig";
import axios from "./authService";

const APPIUM_URL_KEY = "qa_appium_url";
const ADB_RUNNER_URL_KEY = "qa_adb_runner_url";

export function getStoredAppiumUrl() {
  return (
    localStorage.getItem(APPIUM_URL_KEY) || "http://host.docker.internal:4723"
  );
}

export function setStoredAppiumUrl(url) {
  if (url) localStorage.setItem(APPIUM_URL_KEY, url);
  else localStorage.removeItem(APPIUM_URL_KEY);
}

export function getStoredAdbRunnerUrl() {
  return localStorage.getItem(ADB_RUNNER_URL_KEY) || "";
}

export function setStoredAdbRunnerUrl(url) {
  if (url) localStorage.setItem(ADB_RUNNER_URL_KEY, url);
  else localStorage.removeItem(ADB_RUNNER_URL_KEY);
}

export async function testAppiumConnection(url) {
  try {
    const res = await axios.post(API_ENDPOINTS.CHECK_APPIUM_CONNECTION, {
      url,
    });

    return res.data.connected;
  } catch (err) {
    console.error("appium connection error: ", err);
    return false;
  }
}
